<template>
    <div>
        <div class="col-xs-12 agx-list-oneInRow" v-bind:style="{'background':'url('+item.thumbPath+')','height':'250px','background-size': '100% auto'}">
            <div>
                <div>
                    <div class="agx-post-tag" style="z-index:999;width:100%;max-width:60%;padding:2px;background:rgba(251,249,249,0.8);">
                        <div style="padding:2px;font-weight:bold;">
                            <div @click="onselect(item)">
                                {{item.title}}
                            </div>
                        </div>
                        <div style="white-space:pre-line;">
                            {{item.textMsg}}
                        </div>
                    </div>
                    <div class="agx-post-intros">
                        <div v-if="item.category!==null" style="text-align:right;">
                            <div class="label label-primary" style="z-index:999;display:inline-block;">{{item.parentCategory.name}} </div> /
                            <div class="label label-info" style="z-index:999;display:inline-block;"> {{item.category.name}} </div>
                        </div>
                    </div>
                    <div class="agx-trans-layer"></div>
                    <div class="col-xs-12">
                        <div class="btn btn-default" @click="onselect(item)">
                            Edit
                        </div>
                    </div>
                    <div class="col-xs-4 col-md-4">
                        <div @click="onselect(item)" v-if="item.thumbPath!==null">
                            <img style="display:inline-block;height:200px;border-bottom-left-radius:10px;border-bottom-right-radius:10px;"
                                 class="agx-post-thumb" :src="item.thumbPath" :title="item.title">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    
    export default {
        components: {
            
        },
        props: ["item"],
        data: function () {
            return {

            }
        },
        methods: {
            onselect: function (ret) {
                this.$emit('onselect',ret);
            }
        },
        mounted: function () {

        }
    }
</script>